import { Component, AfterViewInit, Input} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetAssignment } from '../../models/entities/asset-assignment';
import { AssetAssignmentService } from '../../services/asset-assignment.service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { AssetAssignmentPipe } from '../../pipes/asset-assignment-pipe';
import { AssetShipment } from '../../models/entities/asset-shipment';
import { AssetShipmentService } from '../../services/asset-shimpnent.service';
import { AssetAssignmentPL } from '../../enums/asset-assignment-pl';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { MatDialog } from '@angular/material/dialog';
import { AssetProductLov } from '../asset-product-lov/asset-product-lov.component';

@Component({
    selector: 'asset-assignment-widget',
    templateUrl: './asset-assignment-widget.component.html',
    styleUrls: ['./asset-assignment-widget.component.scss']
})

export class AssetAssignmentWidgetComponent extends BaseWidget implements AfterViewInit {

  assetAssignmentPL = AssetAssignmentPL;
  
  @Input() assetShipments : AssetShipment[] = [];

  assetAssignment         : AssetAssignment = new AssetAssignment();
  branchs                 : Branch[]        = null;
  assetShipmentCode       : string;
  expeditionForecastDate  : Date;
  barCode                 : string;
  contractPdf             : string;
  

  constructor(
      protected networkService        : LeanNetworkService,
      protected controlTablesService  : ControlTablesService,
      protected assetAssignmentService: AssetAssignmentService,
      protected assetShipmentService  : AssetShipmentService,
      protected toastr                : ToastrService,
      protected dialog                : MatDialog,
      protected leanUtilsService      : LeanUtilsService) {
      super(toastr, leanUtilsService);
  }


//---------------------------------------------------------------------------------------
  ngOnInit(){    
    super.ngOnInit();         
    this.controlTablesService.branchsGet().then(branchs => {
      this.branchs = branchs; 
    }) 
    
    // New Asset Assignment case
    //------------------------------------------------------------------
    if (this.assetAssignment.inserted) {
        this.assetAssignment.branch = new Branch();
        this.assetAssignment.partner = new Partner();
    }
    //------------------------------------------------------------------

  }
//---------------------------------------------------------------------------------------


 //--------------------------------------------------------------------------------------------------------
 setEntity(assetAssignment: AssetAssignment) {
      this.assetAssignment  = { ...assetAssignment };
  }
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.assetAssignment;
  }
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
  saveRow() : Promise<AssetAssignment>{
      return this.assetAssignmentService.assetAssignmentSave(this.assetAssignment);
  }
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
assetAssignmentProcess(service : string){

  if ( (service == 'validateReturn')  && (this.assetAssignment.progressLevel == AssetAssignmentPL.pl_redeploy_requested) ) {
    this.assetAssignmentProcessValidateReturn(service);
    return;
  }

  if (service == 'contractSigned') {
    if (! this.contractPdf) {
      this.showError("Au préalable, Il est nécessaire de faire le upload du contrat scanné au format PDF");
      return;
    }
  }

  this.assetAssignmentService.assetAssignmentProcess(this.assetAssignment.assetAssignmentCode, service, this.expeditionForecastDate, this.barCode, this.contractPdf).then(assetAssignment => {
    this.assetAssignment = assetAssignment; 
    this.leanUtilsService.success();
    if (service =='contractPrint'){
      this.printContract();
    } 
  }) 
}
//--------------------------------------------------------------------------------------------------------
 

//--------------------------------------------------------------------------------------------------------
assetAssignmentProcessValidateReturn(service : string){
  let dialogRef = this.dialog.open(AssetProductLov);
  dialogRef.afterClosed().subscribe(assetProduct => {
    if(assetProduct){
      this.assetAssignmentService.assetAssignmentProcess(this.assetAssignment.assetAssignmentCode, service, this.expeditionForecastDate, this.barCode, this.contractPdf, assetProduct.assetProductCode).then(assetAssignment => {
        this.assetAssignment = assetAssignment; 
        this.leanUtilsService.success();
      }) 
    }
  });
}
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
setShipment(){
  if (! this.assetShipmentCode) {
    this.leanUtilsService.error("Prière de renseigner le code Expédition");
    return;
  }
  this.assetAssignmentService.assetAssignmentShipmentSet(this.assetShipmentCode, this.assetAssignment.assetAssignmentCode).then(assetAssignment => {
      this.leanUtilsService.success();
      this.assetAssignment = assetAssignment; 
  });
}
//--------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------
cancelShipment(){
  this.assetAssignmentService.assetAssignmentShipmentSet(null, this.assetAssignment.assetAssignmentCode).then(assetAssignment => {
      this.leanUtilsService.success();
      this.assetAssignment = assetAssignment; 
  });
}
//--------------------------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
assetTransferPipe  : AssetAssignmentPipe = new AssetAssignmentPipe();
getAssetAssignmentStatus() : string{
  return this.assetTransferPipe.transform(this.assetAssignment, 'progressLevel');
}
//---------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------
decharge(){
  window.open("http://51.91.97.127:9156/ReportServer_SQLSERV?%2fFrigo+Danone%2fDechargeFrigo&rs:Format=PDF&pPosName=Valeur&pPosCode=Valeur&pPosAddress=Valeur&pPosSector=Valeur&pPosCity=Valeur&pPosGSM=Valeur&pPosTel=Valeur&pPosPersonName=Valeur&pPosCIN=Valeur&pPosPersonAddress=Valeur&pPosPatent=Valeur&pCoolerType=Valeur&pCoolerModel=Valeur&pCoolerSerial=Valeur&pCoolerCode=Valeur&pCoolerPrice=77764");
}
printContract(){
  window.open("http://51.91.97.127:9156/ReportServer_SQLSERV?%2fFrigo+Danone%2fContratFrigo&rs:Format=PDF&pPosName=Valeur&pPosCode=Valeur&pPosAddress=Valeur&pPosSector=Valeur&pPosCity=Valeur&pPosGSM=Valeur&pPosTel=Valeur&pPosPersonName=Valeur&pPosCIN=Valeur&pPosPersonAddress=Valeur&pPosPatent=Valeur&pCoolerType=Valeur&pCoolerModel=Valeur&pCoolerSerial=Valeur&pCoolerCode=Valeur&pCoolerPrice=77764");
}

showContract(){
  this.assetAssignmentService.assetAssignmentContractGet(this.assetAssignment.assetAssignmentCode).then(contractPdf => {
    window.open(contractPdf , '_blank');
  }) 
}
//---------------------------------------------------------------------------------------




  setImage(input : any) {
    let files: FileList = input.files ? input.files : input.srcElement.files; 
    this.getBase64(files[0]).then( result =>{
      this.contractPdf = result;
      input.value = "";
  })
    // then the call to post method as normal...
  }


  getBase64(file): Promise<any> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
  }

  printReturnVoucher() {
    window.open("http://51.91.97.127:9156/ReportServer_SQLSERV?%2fFrigo+Danone%2fContratFrigo&rs:Format=PDF&pPosName=Valeur&pPosCode=Valeur&pPosAddress=Valeur&pPosSector=Valeur&pPosCity=Valeur&pPosGSM=Valeur&pPosTel=Valeur&pPosPersonName=Valeur&pPosCIN=Valeur&pPosPersonAddress=Valeur&pPosPatent=Valeur&pCoolerType=Valeur&pCoolerModel=Valeur&pCoolerSerial=Valeur&pCoolerCode=Valeur&pCoolerPrice=77764");
  }

}
